import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-windowStop",
  "use": "icon-windowStop-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-windowStop\"><defs><clipPath id=\"icon-windowStop_a\"><path data-name=\"矩形 85\" d=\"M0 0h18v18H0z\" /></clipPath></defs><g clip-path=\"url(#icon-windowStop_a)\"><path data-name=\"暂停 停止\" d=\"M11.689 3.628a1.181 1.181 0 0 0-1.153 1.151v8.443a1.153 1.153 0 0 0 2.307 0V4.779a1.181 1.181 0 0 0-1.154-1.151zm-5.38 0a1.181 1.181 0 0 0-1.153 1.151v8.443a1.181 1.181 0 0 0 1.153 1.15 1.181 1.181 0 0 0 1.154-1.15V4.779a1.183 1.183 0 0 0-1.154-1.151z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol